import { CreditReportReasonsComponent } from './credit-report-reasons.component';
import { CreditReportSummarySearchComponent } from './credit-report-summary-search.component';
import { CreditReportSummaryComponent } from './credit-report-summary.component';
import { PaginationComponent } from './pagination.component';
export const components: any[] = [CreditReportReasonsComponent, CreditReportSummarySearchComponent, CreditReportSummaryComponent, PaginationComponent];

export * from './credit-report-reasons.component';
export * from './credit-report-summary-search.component';
export * from './credit-report-summary.component';
export * from './pagination.component';
